/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ToolUsageTraceSummary,
  ToolUsageTraceSummary$inboundSchema,
} from "./toolusagetracesummary.js";

/**
 * Result of listing target-aware MCP and tool usage traces
 */
export type ListToolUsageTracesResult = {
  /**
   * Cursor for next page
   */
  nextCursor?: string | undefined;
  /**
   * Target-aware tool usage trace rows
   */
  traces: Array<ToolUsageTraceSummary>;
};

/** @internal */
export const ListToolUsageTracesResult$inboundSchema: z.ZodMiniType<
  ListToolUsageTracesResult,
  unknown
> = z.pipe(
  z.object({
    next_cursor: z.optional(z.string()),
    traces: z.array(ToolUsageTraceSummary$inboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      "next_cursor": "nextCursor",
    });
  }),
);

export function listToolUsageTracesResultFromJSON(
  jsonString: string,
): SafeParseResult<ListToolUsageTracesResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListToolUsageTracesResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListToolUsageTracesResult' from JSON`,
  );
}
